module.exports = __webpack_public_path__ + "static/6305-woodrose-9-f593582f0f1639c174c64596d647372b.jpg";